import * as ko from 'knockout';

declare var DobryKantor: any;

export class WhoTrustedDoradcyFirmyComponent {
    index: ko.Observable<number>;
    timer: any;

    executeTimer() {
        this.timer = setTimeout(() => {
            this.index(this.index() % 7 + 1);
            this.executeTimer();
        }, 3000);
    }

    constructor() {
        this.index = ko.observable(1);
        this.executeTimer();
    }

    isCurrentIndex(index: any) {
        return this.index() === index;
    }

    moveLeft() {
        clearTimeout(this.timer);
        let newIndex = (this.index() - 1) % 7;
        if (newIndex === 0) {
            newIndex = 7;
        }

        this.index(newIndex);
    }

    moveRight() {
        clearTimeout(this.timer);
        this.index(this.index() % 7 + 1);
    }
}
